module.exports = __webpack_public_path__ + "wze-zielonka.jpg?10e85a27fc3af6f455ea7a6a0c19d185";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/trusted/wze-zielonka.jpg
// module id = 149
// module chunks = 0